export default __webpack_public_path__ + "static/media/heart-o.08c15c23.svg";